import { z } from 'zod';

export const extraServiceSchema = z.object({
  id: z.string(),
  label: z.string(),
});

export type ExtraService = z.infer<typeof extraServiceSchema>;
